import React from "react";
import { Container } from "../app.style";
import HeroComponent from "../components/hero-component";
// import FeaturesComponent from "../components/features.component";
// import RoadmapComponent from "../components/roadmap.component";
// import FaqComponent from "../components/faq.component";

const HomeScreen = () => {
  return (
    <main>
      <section id="hero">
        <Container>
          <HeroComponent />
        </Container>
      </section>
      {/* <section id="features">
        <Container>
          <FeaturesComponent />
        </Container>
      </section>*/}
      {/*<section id="roadmap">
        <Container>
          <RoadmapComponent />
        </Container>
      </section>*/}
      {/*<section id="faq">
        <Container>
          <FaqComponent />
        </Container>
      </section>*/}
    </main>
  );
};

export default HomeScreen;
